import { ColumnDefinitionsModel } from './column-definitions.model'
import { PaginationsModel } from './paginations.model';

export class DisableRowConditionModel {
  field: string;
  value: any;
}

export class GridOptionsModel {
  enableFiltering: boolean;
  columnDefinitions: Array<ColumnDefinitionsModel>;
  enableSorting: boolean;
  gridData: any;
  Paginations: PaginationsModel;
  searchPlaceHolder: string;
  searchDescriptions: string;
  numberSearchOnly?: true;
  ctnMask?: boolean;
  callbacks: any;
  multiSelect: boolean;
  showPaginationIndex: boolean;
  disableGrid: boolean;
  disableRow: boolean;
  emptyMessage: string;
  disableRowCondition: DisableRowConditionModel; // Its mandatory when disabledByCondition is true
  disableRowConditionInverse: boolean;
  enableBackLink?: boolean;
  backLinkText?: string;
  isEmptyMessageInRow: boolean; //Used to display emptyMessage in entire Row
  showGrid?: boolean;
  enableSearchLimit?: boolean; //Used to restrict search characters
  searchLimit?: number;// Used to limit no.of.characters for search
  maxLength?: number;
  searchType?: string;
  ariaLabel?: string;
  disableSelectAll: boolean;
  frameworkComponents: any;

  constructor() {
    this.showPaginationIndex = true;
    this.showGrid = true;
    this.disableRowConditionInverse = false;
  }
}
